import React, { Fragment, useEffect } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

import Login from 'screens/Login';
import Main from 'screens/Main';
import SettingPrinter from 'screens/SettingPrinter';
import Result from 'screens/Result';

export default function Routes(props) {
  return (
    <Switch>
      <Route path="/login" component={Login} />
      <Route path="/main" component={Main} />
      <Route path="/settingPrinter" component={SettingPrinter} />
      <Route path="/result" component={Result} />
      <Route path="/" render={() => <Redirect to="/login" />} /> {/* 기본 라우트 */}
    </Switch>
  );
}
